module.exports = __webpack_public_path__ + "media/9.06e0f0d2.mp3";